import { useState, useEffect, useCallback } from 'react';

export function useViewport() {
  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);
  const [viewportHeight, setViewportHeight] = useState(0);
  const [isKeyboardVisible, setIsKeyboardVisible] = useState(false);
  const [keyboardHeight, setKeyboardHeight] = useState(0);

  const updateViewportMetrics = useCallback(() => {
    const hasVisualViewport = typeof window !== 'undefined' && 'visualViewport' in window;
    const windowWidth = window.innerWidth;
    const windowHeight = window.innerHeight;
    
    setWidth(windowWidth);
    setHeight(windowHeight);

    const newHeight = hasVisualViewport ? window.visualViewport!.height : window.innerHeight;
    const heightDiff = Math.abs(windowHeight - newHeight);
    const isKeyboard = heightDiff > 150;

    setViewportHeight(newHeight);
    setIsKeyboardVisible(isKeyboard);
    setKeyboardHeight(isKeyboard ? heightDiff : 0);

    // Обновляем CSS-переменные
    document.documentElement.style.setProperty('--real-vh', `${newHeight}px`);
    document.documentElement.style.setProperty('--keyboard-height', `${isKeyboard ? heightDiff : 0}px`);
    document.documentElement.style.setProperty('--keyboard-visible', isKeyboard ? '1' : '0');
  }, []);

  useEffect(() => {
    updateViewportMetrics();

    let resizeTimeout: number | null = null;
    const debouncedUpdate = () => {
      if (resizeTimeout) {
        window.cancelAnimationFrame(resizeTimeout);
      }
      resizeTimeout = window.requestAnimationFrame(updateViewportMetrics);
    };

    if (typeof window !== 'undefined' && window.visualViewport) {
      window.visualViewport.addEventListener('resize', debouncedUpdate);
      window.visualViewport.addEventListener('scroll', debouncedUpdate);
    }
    window.addEventListener('resize', debouncedUpdate);

    return () => {
      if (window.visualViewport) {
        window.visualViewport.removeEventListener('resize', debouncedUpdate);
        window.visualViewport.removeEventListener('scroll', debouncedUpdate);
      }
      window.removeEventListener('resize', debouncedUpdate);
      if (resizeTimeout) {
        window.cancelAnimationFrame(resizeTimeout);
      }
    };
  }, [updateViewportMetrics]);

  return {
    width,
    height,
    viewportHeight,
    realVh: viewportHeight,
    isKeyboardVisible,
    keyboardHeight,
  };
}
